import { ReactNode, useCallback, Fragment } from 'react';

export interface StatsGridItem {
  id: string;
  name: string | ReactNode;
  change?: string;
  changeType?: 'positive' | 'negative';
  value: string | ReactNode;
  secondaryValue?: string | ReactNode;
}

interface Props {
  stats: StatsGridItem[];
  className?: string;
}

function classNames(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}

export default function DynamicStats({ stats, className = '' }: Props) {
  const filterStats = useCallback(() => {
    return stats.filter(
      (stat) =>
        !['Active Variants', 'Page Speed Score'].includes(stat.name as string),
    );
  }, [stats]);

  return (
    <dl
      className={classNames(
        'mx-auto flex w-full flex-row items-center gap-8 sm:gap-12',
        className,
      )}
    >
      {filterStats().map((stat, index) => (
        <Fragment key={stat.id}>
          <div
            className={classNames(
              'flex min-w-32 flex-1 shrink-0 flex-col gap-1',
            )}
          >
            <dt className="text-base-500 text-sm font-medium">{stat.name}</dt>
            <div className="flex items-baseline gap-2">
              <dd className="text-base-900 text-2xl font-semibold tracking-tight">
                {stat.value}
              </dd>
              {!!stat.change && (
                <dd
                  className={classNames(
                    stat.changeType === 'negative'
                      ? 'text-red-600'
                      : 'text-green-600',
                    'text-sm font-medium',
                  )}
                >
                  {stat.change ?? '0.00%'}
                </dd>
              )}
            </div>
          </div>
          {index < filterStats().length - 1 && (
            <div className="bg-base-200 h-[52px] w-[1px]"></div>
          )}
        </Fragment>
      ))}
    </dl>
  );
}
